<template>
    <div class="wrap">
        <div>
            <Banner></Banner>
        </div>
        <div class="content">
            <div class="model">
                <a class="require-info" @click="requireShow=true"><u>{{requireInfo}}</u></a>
                <span></span>
                <label></label>
                <a href="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/%E6%8A%A5%E5%91%8A%E6%A8%A1%E6%9D%BF.pptx"><u>{{model}}</u></a>
            </div>
            <div class="question-wrap" v-for="(question,index) in questions" v-bind:key="index">
                <div v-if="question.show">
                    <div class="question">
                        <label>{{question.question}}({{question.type==1?"单选题":"多选题"}})</label>
                    </div>
                    <div class="resolves">
                        <div class="resolve" v-for="(resolve,index) in question.resolves" v-bind:key="index" @click="resolveSelect(question,resolve)">
                            <span class="radio" :class="resolve.check==0?'radio-uncheck':'radio-check'"></span>
                            <label>{{resolve.resolve}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="question-wrap" v-if="inputShow">
                <div class="question">
                    <label>5、若既往/就诊时血压未达标，所用降压方案为：</label>
                </div>
                <div class="resolves">
                    <input type="text" placeholder="请填写降压方案" v-model="inputQuestion">
                </div>
            </div>


            <div class="question-wrap" v-if="question_last.show">
                <div class="question">
                    <label>{{question_s_last.question}}({{question_s_last.type==1?"单选题":"多选题"}})</label>
                </div>
                <div class="resolves">
                    <div class="resolve" v-for="(resolve,index) in question_s_last.resolves" v-bind:key="index" @click="resolveSelect(question_s_last,resolve)">
                        <span class="radio" :class="resolve.check==0?'radio-uncheck':'radio-check'"></span>
                        <label>{{resolve.resolve}}</label>
                    </div>
                </div>
            </div>


            <div class="question-wrap" v-if="question_last.show">
                <div class="question">
                    <label>{{question_last.question}}({{question_last.type==1?"单选题":"多选题"}})</label>
                </div>
                <div class="resolves">
                    <div class="resolve" v-for="(resolve,index) in question_last.resolves" v-bind:key="index" @click="resolveSelect(question_last,resolve)">
                        <span class="radio" :class="resolve.check==0?'radio-uncheck':'radio-check'"></span>
                        <label>{{resolve.resolve}}</label>
                    </div>
                </div>
            </div>


            <div class="title">
                <input type="text" placeholder="请填写病例题目" v-model="title">
            </div>
            <div class="result" v-if="resultShow==-1">
                <label>病例审核结果：</label>
                <span>{{caseResult}}</span>
            </div>
            <div class="case">
                <div class="plus">
                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/plus.png" v-if="!choose">
                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/pdf.png" v-if="choose">
                    <input id="case" type="file" accept="application/pdf" multiple="multiple" @change="fileChange" ref="file">
                </div>
                <div class="text" >
                    <label >{{fileName}}</label>
                </div>
                <div>
                    <label class="zoom" @click="pdfzoom" v-if="choose"></label>
                </div>
            </div>
            <div class="submit" @click="toCaseSubmit">
                <label>{{submit}}</label>
            </div>
        </div>

        <div class="require" v-if="requireShow">
            <div class="close" @click="requireShow = false">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_close.png">
            </div>
            <div class="require-content">
                    <div class="title">
                        <span>病例要求</span>
                    </div>
                    <div class="info">
                        <ol>
                            <li>
                                <label>病历资料相对完整</label>
                                <ul>
                                    <li>患者基本信息完整，包括基本情况、既往史类等</li>
                                    <li>诊断层面，包含体格检查、实验室检查、心电图、各种必需的影像学检查，及所需鉴别诊断等</li>
                                    <li>治疗层面，包括基于初步诊断、临床诊断的各阶段治疗方案，治疗结果及随访等</li>
                                </ul>
                            </li>
                            <li>
                                <label>患者类型为需进行联合治疗的高血压患者，例如：</label>
                                <ul>
                                    <li>起始治疗采用单片复方制剂（SPC）</li>
                                    <li>当前治疗血压不达标需换用SPC</li>
                                    <li>伴有合并症或靶器官损害的高血压患者，如：糖尿病，冠心病，肾脏病，肥胖，左心室肥厚，蛋白尿等</li>
                                </ul>
                            </li>
                            <li>
                                <label>其他复杂情况下的高血压患者</label>
                            </li>
                        </ol>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OSS from "ali-oss";
    import {getUuid} from "@/assets/util/util";
    import {getOssSecret,ksdAddStarCase,ksdDocGetStar} from "@/assets/js/api";
    import {Indicator} from "mint-ui";
    import Banner from "@/components/ksd/fragment/Banner";

    export default {
        name: "case",
        components:{
          Banner
        },
        data(){
            return{
                requireShow:false,
                model: '下载病例报告模板',
                requireInfo:"查看病例报告要求",
                submit:"提交",
                choose:false,
                fileName:"请上传病例PDF",
                ossKeySecret:'',
                ossPrefix:"ksd/case/",
                pdfLink:"",
                docId:this.$store.state.ksd_docId,
                title:"",
                // star:this.$route.params.star,
                exa:this.$route.params.exa,
                resultShow:"",
                caseResult:"",
                questions: [
                    {
                        question:"1、患者是否为新诊断高血压？",
                        type:"1",
                        show:true,
                        resolves:[{
                            resolve:"A. 是",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"B. 否",
                            check:0,
                            isAnswer:0
                        }]},
                    {
                        question:"2、患者就诊时，血压值为？",
                        type:"1",
                        show:true,
                        resolves:[{
                            resolve:"A. SBP＞180 mmHg 和/或 DBP＞110 mmHg",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. SBP 160~179 mmHg 和/或 DBP 100~109 mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. SBP 140~159 mmHg 和/或 DBP 90~99 mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D. SBP 120~139 mmHg 和/或 DBP 80~89 mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"E. 单纯收缩期高血压",
                            check:0,
                            isAnswer:0
                        }]},
                    {
                        question:"3、患者就诊时，心血管风险水平处于哪种级别？",
                        type:"1",
                        show:true,
                        resolves:[{
                            resolve:"A. 低危",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 中危",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C. 中/高危",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 高危",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 很高危",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"4、若既往/就诊时血压未达标，曾用降压药物方案为？",
                        type:"1",
                        show:true,
                        resolves:[{
                            resolve:"A. 初次诊断，未用药",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 单药治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C. 自由联合治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 单片复方制剂（SPC）治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 其他降压方案",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"5、若既往/就诊时为单药治疗未达标，曾选用哪种单药？",
                        type:"1",
                        show:false,
                        resolves:[{
                            resolve:"A. CCB类",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. ACEI",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C. ARB",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 利尿剂类",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 其他单一降压药物",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"5、若既往/就诊时为自由联合治疗未达标，曾尝试哪种联合方式？",
                        type:"1",
                        show:false,
                        resolves:[{
                            resolve:"A. CCB+ACEI",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. CCB+ARB",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C. 利尿剂+RAAS抑制剂类",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 利尿剂+CCB+RAAS抑制剂",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 其他药物组合",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"5、若既往/就诊时为SPC治疗未达标，选用了哪种SPC？",
                        type:"1",
                        show:false,
                        resolves:[{
                            resolve:"A. 培哚普利/氨氯地平 SPC",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 培哚普利/吲达帕胺 SPC",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C. 其他类型的SPC",
                            check:0,
                            isAnswer:1
                        }]
                    },
                ],
                question_s_last: {
                    question:"6、目前（至本次调研），该患者血压是否达标，血压值为",
                    type:"1",
                    show:false,
                    resolves:[{
                        resolve:"A. 是 ≤120/80 mmHg",
                        check:0,
                        isAnswer:1
                    },{
                        resolve:"B. 是 ≤130/80 mmHg",
                        check:0,
                        isAnswer:1
                    },{
                        resolve:"C. 是 ≤140/90 mmHg",
                        check:0,
                        isAnswer:1
                    },{
                        resolve:"D. 至本次调研，患者血压仍未达标",
                        check:0,
                        isAnswer:1
                    }]
                },
                question_last: {
                    question:"7、目前（至本次调研），该患者是否只服用足剂量培哚普利/氨氯地平1种降压药？",
                    type:"1",
                    show:false,
                    resolves:[{
                    resolve:"A. 是",
                    check:0,
                    isAnswer:1
                },{
                    resolve:"B. 否",
                    check:0,
                    isAnswer:1
                }]
            },
                inputShow:false,
                inputQuestion:""
            }
        },
        methods:{
            showRequire(){
                this.$toast("show require")
            },
            async ossUpload(file){
                let client = new OSS({
                    region: 'oss-cn-beijing',
                    accessKeyId: 'LTAINtmi5XZ7NaV5',
                    accessKeySecret: this.ossKeySecret,
                    bucket: 'ymd-lcc'
                })

                let uuid = getUuid()
                uuid+=("."+file.name.split(".")[1])
                let key = this.ossPrefix + uuid

                let link=""
                await client.put(key, file).then(function (res) {
                    let str = res.res.requestUrls[0]
                    let status = res.res.status
                    if(status == 200){
                        const workLink =  str.split("?")[0];
                        link = workLink
                    }else {
                        this.$toast("上传失败")
                    }
                }).catch((err) => {
                    console.log(err,"异常啦")
                    this.$toast("无法获取视频，请更换手机重试")
                })

                return link
            },
            resolveSelect(item,resolve){
                let type = item.type
                if(type==1){//单选题
                    for(let r of item.resolves){
                        r.check = 0
                    }
                    resolve.check=1
                }else{  //多选题
                    if(resolve.check==0){
                        resolve.check=1
                    }else{
                        resolve.check=0
                    }
                }

                if(item.question.indexOf("若既往/就诊时血压未达标，曾用降压药物方案为？")!=-1){

                    this.questions[4].show = false
                    this.questions[5].show = false
                    this.questions[6].show = false
                    this.inputShow = false

                    this.question_s_last.question = this.question_s_last.question.replace("5","6")
                    this.question_last.question = this.question_last.question.replace("6","7")
                    if(resolve.resolve.indexOf("A.")!=-1){
                        console.log("still")
                        this.question_s_last.question = this.question_s_last.question.replace("6","5")
                        this.question_last.question = this.question_last.question.replace("7","6")
                    }
                    else if(resolve.resolve.indexOf("B.")!=-1){
                        this.questions[4].show = true
                    }
                    else if(resolve.resolve.indexOf("C.")!=-1){
                        this.questions[5].show = true
                    }
                    else if(resolve.resolve.indexOf("D.")!=-1){
                        this.questions[6].show = true
                    }
                    else if(resolve.resolve.indexOf("E.")!=-1){
                        this.inputShow =true
                    }
                    this.question_last.show = true

                }

            },
            getAnswer(index){
                const question = this.questions[index-1]
                let resolves = question.resolves;
                let answer="";
                for(let resolve of resolves){
                    if(resolve.check==1){
                        answer+=resolve.resolve+","
                    }
                }
                return answer.substring(0,answer.length-1)
            },

            getSLastAnswer(){
                const question = this.question_s_last
                let resolves = question.resolves;
                let answer="";
                for(let resolve of resolves){
                    if(resolve.check==1){
                        answer+=resolve.resolve+","
                    }
                }
                return answer.substring(0,answer.length-1)
            },
            getLastAnswer(){
                const question = this.question_last
                let resolves = question.resolves;
                let answer="";
                for(let resolve of resolves){
                    if(resolve.check==1){
                        answer+=resolve.resolve+","
                    }
                }
                return answer.substring(0,answer.length-1)
            },
            fileChange(event){
                console.log(event)
                let fr = new FileReader();
                this.fileName = event.target.files[0].name

               let suffix =  this.fileName.substring(this.fileName.lastIndexOf(".")+1,this.fileName.length);
                if(suffix.toLocaleLowerCase()!="pdf"){//只能选取PDF文件
                    this.$toast("请选择PDF文件")
                    return
                }

                fr.readAsDataURL(event.target.files[0]);
                let _this = this
                fr.onload = function (e) {
                    console.log(e)
                    _this.choose = true
                    Indicator.open({
                        text: '上传中',
                        spinnerType: 'fading-circle'
                    });
                    _this.ossUpload(_this.$refs.file.files[0]).then(function (res) {
                        console.log(res,'pdf上传成功！！！')
                        _this.pdfLink = res
                        Indicator.close();
                    })

                };
            },
            pdfzoom() {
                // this.$toast("开始查看")
                this.$router.push({path:"pdf",query:{url:this.pdfLink}})
            },
            async getSecret(){
                const res = await getOssSecret();
                console.log(res,"secret res")
                if(res.data.success==true){
                    this.ossKeySecret = res.data.data.accessKeySecret;
                }
            },
            toCaseSubmit(){
                for(let i=1;i<=4;i++){
                    let docAnswer = this.getAnswer(i);
                    if(docAnswer ==null||docAnswer==""){
                        this.$toast("请选择第"+i+"题答案")
                        return;
                    }
                }

                let q4=this.getAnswer(4);

                let q5=null
                let q6=null
                let q7=null
                if(q4.indexOf("A.")!=-1){
                    q5 = " "
                }else if(q4.indexOf("B.")!=-1){
                    q5 = this.getAnswer(5)
                }else if(q4.indexOf("C.")!=-1){
                    q5 = this.getAnswer(6)
                }else if(q4.indexOf("D.")!=-1){
                    q5 = this.getAnswer(7)
                } else if(q4.indexOf("E.")!=-1){
                    q5 = this.inputQuestion
                }

                q6 = this.getSLastAnswer()
                q7 = this.getLastAnswer()


                console.log(q5,"q5")

                if(q5==null||q5==""){
                    this.$toast("请选择第5题答案")
                    return
                }
                if(q6==null||q6==""){
                    if(q4.indexOf("A.")!=-1){
                        this.$toast("请选择第5题答案")
                    }else{
                        this.$toast("请选择第6题答案")
                    }

                    return
                }
                if(q7==null||q7==""){
                    if(q4.indexOf("A.")!=-1){
                        this.$toast("请选择第6题答案")
                    }else{
                        this.$toast("请选择第7题答案")
                    }
                    return
                }

                if(this.title==""){
                    this.$toast("请添加病例题目")
                    return
                }
                if(this.pdfLink==""){
                    this.$toast("请选择病例")
                    return
                }

                this.caseSubmit(this.docId,this.getAnswer(1),this.getAnswer(2),this.getAnswer(3),q4,q5,q6,q7,this.title,this.pdfLink)
            },
            async caseSubmit(docId,q1,q2,q3,q4,q5,q6,q7,title,pdf){
                let exa = this.exa
                const res = await ksdAddStarCase({docId,q1,q2,q3,q4,q5,q6,q7,title,pdf,exa})
                if(res.data.success){
                    this.$router.push({path:"docCode"})
                }else{
                    this.$toast(res.data.message)
                }
            },
            async getStar(docId,exa){
                const res = await ksdDocGetStar({docId,exa})
                console.log(res,"star res")
                if(res.data.data.caseWork==null){
                    return
                }
                this.resultShow = res.data.data.caseVerify
                this.caseResult = res.data.data.caseDenyReason
                this.resolveDeal(1,res.data.data.caseQ1)
                this.resolveDeal(2,res.data.data.caseQ2)
                this.resolveDeal(3,res.data.data.caseQ3)
                this.resolveDeal(4,res.data.data.caseQ4)

                let q4 = res.data.data.caseQ4
                console.log(q4,"q4 dadada")

                if(q4.indexOf("A.")!=-1){
                    console.log("still")
                    this.question_s_last.question = this.question_s_last.question.replace("6","5")
                    this.question_last.question = this.question_last.question.replace("7","6")
                }
                else if(q4.indexOf("B.")!=-1){
                    this.questions[4].show = true
                    this.resolveDeal(5,res.data.data.caseQ5)
                }
                else if(q4.indexOf("C.")!=-1){
                    this.questions[5].show = true
                    this.resolveDeal(6,res.data.data.caseQ5)
                }
                else if(q4.indexOf("D.")!=-1){
                    this.questions[6].show = true
                    this.resolveDeal(7,res.data.data.caseQ5)
                }
                else if(q4.indexOf("E.")!=-1){
                    this.inputShow =true
                    this.inputQuestion = res.data.data.caseQ5
                }

                this.slastResolve(res.data.data.caseQ6)
                this.lastResolve(res.data.data.caseQ7)


                this.question_last.show = true

                 this.title = res.data.data.caseTitle
                 this.pdfLink = res.data.data.caseWork
                 if(this.pdfLink!=null&&this.pdfLink!=""){
                     this.choose = true
                 }
                 this.fileName=""
            },
            resolveDeal(index,resolve){
                console.log(index,resolve)
                if(this.Index>=this.questions.length-1) return
                let q = this.questions[index-1]
                for(let item of q.resolves){
                    let b = resolve.split(",")
                    for(let c of b){
                        if(item.resolve==c){
                            item.check=1
                        }
                    }

                }
            },
            slastResolve(resolve){
                let q = this.question_s_last
                for(let item of q.resolves){
                    let b = resolve.split(",")
                    for(let c of b){
                        if(item.resolve==c){
                            item.check=1
                        }
                    }

                }
            },
            lastResolve(resolve){
                let q = this.question_last
                for(let item of q.resolves){
                    let b = resolve.split(",")
                    for(let c of b){
                        if(item.resolve==c){
                            item.check=1
                        }
                    }

                }
            }

        },
        mounted(){
            console.log("exa="+this.exa)
            this.getSecret()
            this.getStar(this.docId,this.exa)
        },
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }
    .content{
        flex-grow: 1;
    }
    .head{
        width: 100%;
        position: relative;
    }
    .content{
        text-align: left;
        width: 90%;
        margin: 0 auto;
        .model{
            display: flex;
            /*justify-content: flex-end;*/
            align-items: center;
            margin-right: 20px;
            width: 100%;
            label{
                width: 42px;
                height: 37px;
                background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_load.png") no-repeat center;
                background-size: 50%;
            }
            a:last-child{
                display: block;
                text-align: center;
                color: #2c9a58;
                font-size: 14px;
            }
            span{
                flex-grow: 1;
            }
            a:first-child{
                height: 30px;
                line-height: 30px;
                text-indent: 22px;
            }
            .require-info{
                background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/question.png") no-repeat 0px 50%;
                background-size: 16px 16px;
                font-size: 14px;
            }
        }
        .question-wrap .question{
            font-weight: bold;
            background: #d6ebe1;
            border-radius: 3px;
            padding: 5px 0 5px 5px;
            /*text-indent: 5px;*/
            /*padding-left: 5px;*/
            border-left: 3px #2c9a58 solid;
            font-size: 16px;
        }
        .question-wrap .resolves .resolve{
            display: flex;
            flex-direction: row;
            margin: 5px 0;
            align-items: center;
            font-size: 15px;
            text-align: left;
            label{
                width: 100%;
            }
        }
        .question-wrap .radio{
            display: block;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            margin: 0px 5px 0px 10px;
        }
        .question-wrap .radio-uncheck{
            border: 1px solid #000;
            background: transparent;
        }
        .question-wrap .radio-check{
            background: #2c9a58;
            border: 1px #2c9a58 solid;
        }
        .title{
        }
        input{
            width: 100%;
            outline: none;
            border: #2c9a58 1px solid;
            border-radius: 2px;
            height: 20px;
            text-indent: 5px;
            margin: 10px 0px;
            font-size: 15px;
        }
        .case{
            width: 100%;
            height: 200px;
            background: #ddd;
            margin: 10px 0;
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;
            position: relative;

            .zoom{
                position: absolute;
                display: block;
                width: 28px;
                height: 28px;
                background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon-zoom.png") no-repeat;
                background-size: cover;
                bottom: 10px;
                right: 10px;
            }

            .plus{
                margin-top: 15px;
                position: relative;
                width: 60px;
                height: 60px;

                input{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    opacity: 0;
                }
            }

            img{
                width: 60px;
                height: 60px;
            }
            .text{
                margin-top:20px;
                font-size: 18px;
                color: #bbb;
            }
        }
        .hint{
            text-align: left;
            word-break: break-all;
        }
    }

    .content .submit{
        margin: 30px 0 30px 0;
        background: #2c9a58;
        text-align: center;
        border-radius: 5px;
        color: #FFF;
        padding: 5px 0;
        font-size: 15px;
    }

    ol{
        padding: 10px;
    }
    ul{
        padding: 0 20px;
    }
    li{
        margin: 2px 0;
    }
    ul li{
        list-style-type: disc;
    }

    .require{
        width: 90%;
        background: #FFF;
        position: absolute;
        top: 22%;
        left: 5%;
        right: 5%;
        bottom: 10%;
        border-radius: 30px;
        font-weight: bold;
        .close{
            text-align: right;
            margin: 15px 15px 0 0 ;
            img{
                width: 30px;
                height: 30px;
            }
        }
        .title{
            font-size: 18px;
            color: #2c9a58;
        }

        ol{
            text-align: left;
            margin: 0 14px;
            line-height: 18px;
            padding-top: 0;
            li::marker{
                color: #2c9a58;
            }
            li label{
                display: block;
                color: #2c9a58;
                margin: 8px 0;
            }
        }
        label{
            color: #2c9a58;
        }
        ul{
            padding-right: 0;
            li::marker{
                color: #000;
            }
        }
    }
    .result{
        font-size: 16px;
        color: #C12935;
    }

</style>
